module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "id": "messageDialog",
      "size": "small",
      "show-close": false,
      "title": _vm.$t('COMPOSEMESSAGE'),
      "visible": _vm.messageBox
    },
    on: {
      "close": _vm.clearCompose,
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }, [_c('el-form', [(!_vm.message && _vm.showRemove) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTRECIPIENT')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTRECIPIENT')
    },
    on: {
      "change": function($event) {
        _vm.compose.RecipientID = ''
      }
    },
    model: {
      value: (_vm.compose.Recipient),
      callback: function($$v) {
        _vm.$set(_vm.compose, "Recipient", $$v)
      },
      expression: "compose.Recipient"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": _vm.$t('RECIPIENT0')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": _vm.$t('RECIPIENT1')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": _vm.$t('RECIPIENT2')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": _vm.$t('RECIPIENT3')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": _vm.$t('RECIPIENT4')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": _vm.$t('RECIPIENT5')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": _vm.$t('RECIPIENT6')
    }
  })], 1)], 1), _vm._v(" "), (_vm.compose.Recipient == 2) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTGRADE')
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "GradeID",
      "placeholder": _vm.$t('SELECTGRADE'),
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.classID = null
      }
    },
    model: {
      value: (_vm.Grade),
      callback: function($$v) {
        _vm.Grade = $$v
      },
      expression: "Grade"
    }
  }, _vm._l((_vm.grades), function(grade, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": grade.Name,
        "value": grade
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.compose.Recipient == 2 && _vm.compose.RecipientID) ? _c('el-form-item', {
    staticClass: "classes",
    attrs: {
      "label": _vm.$t('SELECTCLASS')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.classID),
      callback: function($$v) {
        _vm.classID = $$v
      },
      expression: "classID"
    }
  }, _vm._l((_vm.Grade.Classes), function(cls, index) {
    return (cls) ? _c('el-radio-button', {
      key: index,
      attrs: {
        "label": cls
      }
    }) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.compose.Recipient == 3 && _vm.buses != '') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTBUS')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": ""
    },
    model: {
      value: (_vm.compose.RecipientID),
      callback: function($$v) {
        _vm.$set(_vm.compose, "RecipientID", $$v)
      },
      expression: "compose.RecipientID"
    }
  }, _vm._l((_vm.buses[4]), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.BusID,
        "label": item.bus_number
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(item.bus_number) + "-" + _vm._s(item.TourName))])])
  }))], 1) : _vm._e(), _vm._v(" "), ((_vm.compose.Recipient == 4 || _vm.compose.Recipient == 5) && _vm.buses != '') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTBUSROUTE')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUSROUTE'),
      "filterable": ""
    },
    on: {
      "visible-change": function($event) {
        _vm.getBoardedTrips()
      }
    },
    model: {
      value: (_vm.compose.RecipientID),
      callback: function($$v) {
        _vm.$set(_vm.compose, "RecipientID", $$v)
      },
      expression: "compose.RecipientID"
    }
  }, _vm._l((_vm.buses[5]), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.bus_number,
        "value": item.TripID
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(item.bus_number) + "-" + _vm._s(item.TourName))])])
  }))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.compose.Recipient == 6 && (_vm.person || _vm.message || (!_vm.message && _vm.showRemove))),
      expression: "compose.Recipient==6 && (person || message || (!message && showRemove))"
    }],
    staticClass: "box-card",
    attrs: {
      "body-style": {
        display: (_vm.message || (!_vm.message && _vm.showRemove)) ? '' : 'none'
      }
    }
  }, [(_vm.person) ? _c('div', {
    staticClass: "media",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.person.ImagePath, (_vm.person.Relation == null || _vm.person.Relation == '' ? 'supervisor' : 'guardian'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("\n                      " + _vm._s(_vm._FullName({
    NameEN: _vm.person.FullName_EN,
    NameAR: _vm.person.FullName_AR
  })) + "\n                      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.person && _vm.showRemove),
      expression: "person && showRemove"
    }],
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-remove",
    on: {
      "click": _vm.clearInput
    }
  })]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s((_vm.person.Relation == null || _vm.person.Relation == '') ? _vm.$t('BUSSUPERVISOR') : _vm.$t(_vm.person.Relation)))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }]
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('CONVERSATION')))]), _vm._v(" "), _c('br'), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.message.Text)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.message && _vm.showRemove),
      expression: "!message && showRemove"
    }]
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHPERSONNAME'),
      "icon": "search"
    },
    on: {
      "select": _vm.addPerson
    },
    model: {
      value: (_vm.personName),
      callback: function($$v) {
        _vm.personName = $$v
      },
      expression: "personName"
    }
  })], 1)]), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.compose.Recipient == 6 && _vm.students.length != 0),
      expression: "compose.Recipient==6 && students.length!=0"
    }],
    staticClass: "box-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('MESSAGEFOR')))]), _vm._v(" "), _vm._l((_vm.students), function(student, key) {
    return _c('el-collapse-transition', {
      key: key
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showStudentsList(student.StudentID)),
        expression: "showStudentsList(student.StudentID)"
      }],
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('img', {
      staticClass: "media-object img-circle",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "src": _vm.getAsset(student.ImagePath, 'student')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_vm._v("\n                              " + _vm._s(_vm._FullName({
      NameEN: student.FullName_EN,
      NameAR: student.FullName_AR
    })) + "\n                              "), (_vm.students.length > 1) ? _c('div', {
      staticClass: "pull-right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('LISTALLSTUDENTS'),
        "placement": "top",
        "effect": "light"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showStudentsList(student.StudentID, true)),
        expression: "showStudentsList(student.StudentID, true)"
      }],
      staticStyle: {
        "padding-right": "8px"
      },
      attrs: {
        "type": "text",
        "icon": "arrow-down"
      },
      on: {
        "click": function($event) {
          _vm.compose.RecipientID = null
        }
      }
    })], 1), _vm._v(" "), _c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": student.StudentID
      },
      model: {
        value: (_vm.compose.RecipientID),
        callback: function($$v) {
          _vm.$set(_vm.compose, "RecipientID", $$v)
        },
        expression: "compose.RecipientID"
      }
    }, [_c('small', [_vm._v(_vm._s(student.IsMain != null ? '' : _vm.$t('NOT')) + " " + _vm._s(_vm.$t('PRIMARY')))])])], 1) : _vm._e()])])])])])
  })], 2), _vm._v(" "), _c('el-card', {
    staticClass: "compose",
    attrs: {
      "body-style": {
        padding: '8px'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "slot": "header",
      "type": "textarea",
      "maxlength": 256,
      "rows": 8,
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    slot: "header",
    model: {
      value: (_vm.compose.Text),
      callback: function($$v) {
        _vm.$set(_vm.compose, "Text", $$v)
      },
      expression: "compose.Text"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    attrs: {
      "on-success": _vm.updateFile,
      "before-upload": _vm.beforeUpload,
      "on-progress": _vm.limitFile,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "action": _vm.URL + 'media/upload',
      "data": {
        folder: 'message',
        type: 'attachment'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.$t('ATTACHMENT')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('FILESWITHASIZE')) + " ")])], 1)], 1), _vm._v(" "), (_vm.attached != null) ? _c('el-col', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-tag', {
    attrs: {
      "closable": _vm.attached,
      "type": _vm.attached ? 'success' : 'primary'
    },
    on: {
      "close": function($event) {
        _vm.handleRemove()
      }
    }
  }, [_c('i', {
    class: {
      'el-icon-loading': !_vm.attached
    }
  }), _vm._v(" " + _vm._s(_vm.attached ? _vm.compose.Attachment.Filename : _vm.$t('ATTACHING')))])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.attached != null ? 6 : 16
    }
  }, [_c('h5', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('CHARACTERSREMAINING')) + " "), _c('span', {
    staticClass: "text-right",
    domProps: {
      "textContent": _vm._s(_vm.textLimit())
    }
  }, [_vm._v("256")])])])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.messageBox = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.validateInput(),
      "loading": _vm.loadingSend
    },
    on: {
      "click": function($event) {
        _vm.sendMessage()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingSend ? _vm.$t('SENDING') : _vm.$t('SEND')))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "small"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.errorMessage), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55cdc5ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/Message.vue
// module id = 599
// module chunks = 1